import {
  BackgroundToLightnessProvider,
  Box,
  Icon,
  useToggle,
} from '@factorialco/deprecated-design-system'

interface Props {
  onClick: () => void
  isVisible?: boolean
}

const AddButton = ({ onClick, isVisible = false }: Props) => {
  const [isHovering, toggleHovering] = useToggle(false)
  return (
    <Box position="relative">
      <Box
        flexDirection="row"
        justifyContent="center"
        alignItems="center"
        height="s24"
        onMouseEnter={toggleHovering(true)}
        onMouseLeave={toggleHovering(false)}
        style={{
          position: 'absolute',
          bottom: '0',
          transform: 'translateY(30%) translateX(-50%)',
          left: '50%',
        }}
      >
        <BackgroundToLightnessProvider>
          <Box
            style={{
              cursor: 'pointer',
              display: 'inline-flex',
              justifyContent: 'center',
              visibility: isVisible || isHovering ? 'visible' : 'hidden',
            }}
          >
            <Box
              boxShadow="s400"
              background="grey000White"
              borderRadius={{
                all: 'abs016',
              }}
              paddingY="s2"
              width="full"
            >
              <Box onClick={onClick} alignItems="center" paddingX="s2" flexDirection="row">
                <Icon.Small icon="add" color="grey1000"></Icon.Small>
              </Box>
            </Box>
          </Box>
        </BackgroundToLightnessProvider>
      </Box>
    </Box>
  )
}

export default AddButton
